/* tslint:disable:no-console */

// See https://github.com/facebook/react/issues/11538#issuecomment-417504600
// Monkey patching to work around issue when user Google Translates a page
// in Chrome
// Remove once bug is fixed in Chrome
// https://bugs.chromium.org/p/chromium/issues/detail?id=872770

export default function patchDOMForGoogleTranslate() {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild: any = Node.prototype.removeChild

    Node.prototype.removeChild = function patchedRemoveChild(child, ...rest) {
      if (child.parentNode !== this) {
        if (typeof console !== 'undefined') {
          console.error(
            'Cannot remove a child from a different parent',
            child,
            this
          )
        }
        return child
      }
      return originalRemoveChild.apply(this, [child, ...rest])
    }

    const originalInsertBefore = Node.prototype.insertBefore
    Node.prototype.insertBefore = function patchedInsertBefore(
      newNode,
      referencedNode,
      ...rest
    ) {
      if (referencedNode && referencedNode.parentNode !== this) {
        if (typeof console !== 'undefined') {
          console.error(
            'Cannot insert before a reference node from a different parent',
            referencedNode,
            this
          )
        }
        return newNode as any
      }
      return originalInsertBefore.apply(this, [
        newNode,
        referencedNode,
        ...rest
      ])
    }
  }
}
